export const PRODUCT_NATURE_RESET_STATE = 'PRODUCT_NATURE_RESET_STATE';
export const PRODUCT_NATURE_CURRENT_ITEM = 'PRODUCT_NATURE_CURRENT_ITEM';

export const PRODUCT_NATURE_REQUEST_LOADING = 'PRODUCT_NATURE_REQUEST_LOADING';
export const PRODUCT_NATURE_REQUEST_SUCCESS = 'PRODUCT_NATURE_REQUEST_SUCCESS';
export const PRODUCT_NATURE_REQUEST_FAILED = 'PRODUCT_NATURE_REQUEST_FAILED';

export const PRODUCT_NATURE_CURRENT_ACTION = 'PRODUCT_NATURE_CURRENT_ACTION';
export const PRODUCT_NATURE_RESET_ACTION = 'PRODUCT_NATURE_RESET_ACTION';